import client from "./client";

const endpoint = "company-information/";

const getCompanyInfo = () => client.get(endpoint);

export { getCompanyInfo };
